/**
 * 첨부파일 압축파일 이름을 반환합니다.
 * @see https://github.com/modusign/modusign-client/pull/7574
 */
export default function getAttachmentBundleName(
  documentTitle: string,
  type: 'REQUESTER' | 'SIGNER' | 'ALL'
): string {
  switch (type) {
    case 'REQUESTER':
      return `${documentTitle}_요청자_첨부파일.zip`;
    case 'SIGNER':
      return `${documentTitle}_서명자_첨부파일.zip`;
    case 'ALL':
    default:
      return `${documentTitle}_첨부파일.zip`;
  }
}
